/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reset_Request_BackInputs */



/**
* | output |
* | --- |
* | "Back to sign in" |
*
* @param {Reset_Request_BackInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reset_request_back = /** @type {((inputs?: Reset_Request_BackInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_Request_BackInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Back to sign in")
});